'use client'

import React, { useState, useMemo, useContext, useEffect } from 'react'

import {
  LocalPaymentMethod,
  PaymentMethod,
} from '@graphql/queries/paymentMethods'

interface IPaymentMethodSelectionContext {
  selectedPaymentMethod?: LocalPaymentMethod
  setSelectedPaymentMethod: (value?: LocalPaymentMethod) => void
}

const PaymentMethodSelectionContext =
  React.createContext<IPaymentMethodSelectionContext>({
    selectedPaymentMethod: undefined,
    setSelectedPaymentMethod: () => {},
  })

export const PaymentMethodSelectionContextProvider: React.FC<
  React.PropsWithChildren<{
    defaultPaymentMethod?: PaymentMethod
  }>
> = ({ children, defaultPaymentMethod }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    PaymentMethod | undefined
  >(defaultPaymentMethod)

  useEffect(() => {
    if (!defaultPaymentMethod) return
    setSelectedPaymentMethod(defaultPaymentMethod)
  }, [defaultPaymentMethod])

  const value = useMemo(
    () => ({
      selectedPaymentMethod,
      setSelectedPaymentMethod,
    }),
    [selectedPaymentMethod, setSelectedPaymentMethod]
  )

  return (
    <PaymentMethodSelectionContext.Provider value={value}>
      {children}
    </PaymentMethodSelectionContext.Provider>
  )
}

export function usePaymentMethodSelectionContext() {
  return useContext(PaymentMethodSelectionContext)
}
